import { i18n } from "@/i18n";
import { AssetTemplateModel } from "@/model/asset/assetModel";
import {
  AccountPurchaseType,
  AccountPurchaseValType,
  AccountScrapType,
  AccountScrapValType,
  AssetTemplateCategoryType,
  AssetTemplateDepreciationPolicyType,
  AssetTemplateSubCategoryType,
  ValidatedErrorCarryBalanceType,
} from "../enums/enums";
import { ReadExcelFile } from "./excelHelper";
import { GetDateJsonString } from "./importHelper";
import { NewObject } from "./shareHelper";
export const codeLimitLenght = 70;
export const nameLimitLenght = 100;
export const barcodeLimitLenght = 40;
export const descriptionLimitLenght = 500;
export const usedFullYearLimit = 99;
export const maxLengthSerialNo = 40;
export const maxLengthLocation = 100;
export const maxLengthDescription = 256;

function GetAssetTemplateSubCategoryList(assetTemplateCategoryType: AssetTemplateCategoryType): any {
  const assetTemplateSubCategoryList = [] as any;
  switch (assetTemplateCategoryType) {
    case AssetTemplateCategoryType.Land:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Land,
        nameTh: "ที่ดิน",
        nameEn: "Land",
        icon: "icon-land",
      });
      break;
    case AssetTemplateCategoryType.ConstructionInProgress:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.ConstructionInProgress,
        nameTh: "งานระหว่างก่อสร้าง",
        nameEn: "Construction in progress",
        icon: "icon-constructionInProgress",
      });
      break;
    case AssetTemplateCategoryType.Building:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Office,
        nameTh: "สำนักงาน",
        nameEn: "Office",
        icon: "icon-Office",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Shop,
        nameTh: "ร้านค้า",
        nameEn: "Shop",
        icon: "icon-shop",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Warehouse,
        nameTh: "โกดัง",
        nameEn: "Warehouse",
        icon: "icon-warehouse",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Factory,
        nameTh: "โรงงาน",
        nameEn: "Factory",
        icon: "icon-factory",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.OtherBuildingAndImprovement,
        nameTh: "อาคารอื่น",
        nameEn: "Other Building",
        icon: "icon-temple",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.BuildingImprovement,
        nameTh: "ส่วนปรับปรุงอาคาร",
        nameEn: "Building Improvement",
        icon: "icon-buildingImprovement",
      });
      break;
    case AssetTemplateCategoryType.FurnitureAndFixture:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Fixture,
        nameTh: "ส่วนติดตั้ง (built-in)",
        nameEn: "Fixture",
        icon: "icon-fixture",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Table,
        nameTh: "โต๊ะ",
        nameEn: "Table",
        icon: "icon-table",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.ChairAndSofa,
        nameTh: "เก้าอี้ ที่นั่ง",
        nameEn: "Chair and sofa",
        icon: "icon-chairAndSofa",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.CabineAndStorage,
        nameTh: "ตู้พื้นที่เก็บของ",
        nameEn: "Cabine and storage",
        icon: "icon-cabineAndStorage",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.OtherFurniture,
        nameTh: "เครื่องตกแต่งสำนักงานอื่น",
        nameEn: "Other furniture",
        icon: "icon-otherFurniture",
      });
      break;
    case AssetTemplateCategoryType.Vehicle:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Motocycle,
        nameTh: "จักรยานยนต์",
        nameEn: "Motocycle",
        icon: "icon-motocycle",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.CarOrVanLessThan10Seats,
        nameTh: "รถยนต์นั่งไม่เกิน 10 ที่นั่ง",
        nameEn: "Car (less then 10 seats)",
        icon: "icon-carOrVanLessThan10Seats",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.CarOrVanMoreThan10Seats,
        nameTh: "รถยนต์นั่งเกิน 10 ที่นั่ง",
        nameEn: "Car (more then 10 seats)",
        icon: "icon-carOrVanMoreThan10Seats",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Truck,
        nameTh: "รถบรรทุก",
        nameEn: "Truck",
        icon: "icon-truck",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.OtherVehicle,
        nameTh: "ยานพาหนะอื่น",
        nameEn: "Other vehicle",
        icon: "icon-ufo",
      });
      break;
    case AssetTemplateCategoryType.Machine:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Machine,
        nameTh: "เครื่องจักรการผลิต",
        nameEn: "Machine",
        icon: "icon-machine",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Equipment,
        nameTh: "อุปกรณ์การผลิต",
        nameEn: "Equipment",
        icon: "icon-equipment",
      });
      break;
    case AssetTemplateCategoryType.Equipment:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.MobliePhone,
        nameTh: "โทรศัพท์มือถือ",
        nameEn: "Moblie Phone",
        icon: "icon-mobliePhone",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.ComputerAndComputerEquipment,
        nameTh: "คอมพิวเตอร์และอุปกรณ์คอมพิวเตอร์",
        nameEn: "Computer & Equipment",
        icon: "icon-computerAndComputerEquipment",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.PrinterOrPrintingEquipment,
        nameTh: "เครื่องพิมพ์และอุปกรณ์การพิมพ์",
        nameEn: "Printer Or Equipment",
        icon: "icon-printerOrPrintingEquipment",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.OtherOfficeEquipment,
        nameTh: "อุปกรณ์และเครื่องใช้สำนักงานอื่น",
        nameEn: "Other Office Equipment",
        icon: "icon-microphone",
      });
      break;
    case AssetTemplateCategoryType.Intangible:
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Software,
        nameTh: "ซอฟท์แวร์",
        nameEn: "Software",
        icon: "icon-software",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.LeaseholdAndLicense,
        nameTh: "สิทธิการเช่าหรือใช้สินทรัพย์",
        nameEn: "Leasehold & License",
        icon: "icon-leaseholdAndLicense",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.CopyRight,
        nameTh: "ลิขสิทธิ์",
        nameEn: "Copy Right",
        icon: "icon-copyRight",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.Patent,
        nameTh: "สิทธิบัตร",
        nameEn: "Patent",
        icon: "icon-patent",
      });
      assetTemplateSubCategoryList.push({
        id: AssetTemplateSubCategoryType.OtherIntengibleAssets,
        nameTh: "สินทรัพย์ไม่มีตัวตนอื่น",
        nameEn: "Other Intengible Assets",
        icon: "icon-ghost",
      });
      break;
  }

  const colorList = ["#6C6DF2", "#FF9649", "#F6C22C", "#03BECC", "#F35B35", "#6C6DF2", "#F58064", "#3297FF", "#A06DCC"];

  assetTemplateSubCategoryList.forEach((assetTemplateSubCategory: any, index: number) => {
    assetTemplateSubCategory.color = colorList[assetTemplateCategoryType];
  });
  return assetTemplateSubCategoryList;
}
export function GetAssetTemplateCategoryList(): any {
  const assetTemplateCategoryList = [];
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.Land,
    nameTh: "ที่ดิน",
    nameEn: "Land",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.Land),
  });
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.ConstructionInProgress,
    nameTh: "งานระหว่างก่อสร้าง",
    nameEn: "Construction in progress",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.ConstructionInProgress),
  });
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.Building,
    nameTh: "อาคาร",
    nameEn: "Building",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.Building),
  });
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.FurnitureAndFixture,
    nameTh: "เครื่องตกแต่งสำนักงาน",
    nameEn: "Furniture and Fixture",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.FurnitureAndFixture),
  });
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.Vehicle,
    nameTh: "ยานพาหนะ",
    nameEn: "Vehicle",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.Vehicle),
  });
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.Machine,
    nameTh: "เครื่องจักรการผลิต",
    nameEn: "Machine",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.Machine),
  });
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.Equipment,
    nameTh: "อุปกรณ์และเครื่องใช้สำนักงาน",
    nameEn: "Equipment",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.Equipment),
  });
  assetTemplateCategoryList.push({
    id: AssetTemplateCategoryType.Intangible,
    nameTh: "ไม่มีตัวตน",
    nameEn: "Intangible",
    isShowSubCategory: false,
    assetTemplateSubCategoryList: GetAssetTemplateSubCategoryList(AssetTemplateCategoryType.Intangible),
  });
  return assetTemplateCategoryList;
}
export function SetTapAssetTemplateTable(tableCount: number) {
  return [
    {
      name: "Table_Tap_All",
      length: tableCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: true,
    },
  ];
}
export function SetHeaderAssetTemplateTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },

    {
      name: "Asset_Group_Number_Table",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Asset_Name_Table",
      sortBy: null,
      sortingType: null,
      width: 100,
      align: "flex-start",
    },
    {
      name: "Number",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Cost_Of_Asset_Table",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Acc_Depre",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Book_Value",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
  ];
  return header;
}
export function SetHeaderAssetUnitTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Asset_Number",
      sortBy: null,
      width: 20,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Name_TH",
      sortBy: null,
      width: 300,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Name_EN",
      sortBy: null,
      width: 300,
      sortingType: null,
      align: "flex-start",
    },

    {
      name: "",
      sortBy: null,
      width: 20,
      sortingType: null,
      align: "flex-end",
    },
  ];
  return header;
}
export function SetTapAssetUnitTable(tableCount: number) {
  return [
    {
      name: "Table_Tap_All",
      length: tableCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: true,
    },
  ];
}
export function SetTapAssetTable(tableCount: number) {
  return [
    {
      name: "Table_Tap_All",
      length: tableCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: true,
    },
  ];
}
export function SetHeaderAssetTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Asset_Table_Doc_Ref",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Asset_Table_Asset_Code",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Purchase_Date_Table",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "Cost_Of_Asset_Table",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Asset_Table_Acc_Depre",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Asset_Table_Book_Value",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Asset_Table_Time_in_Used",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
  ];
  return header;
}
export function SetTapAssetDepreciationTable(tableCount: number) {
  return [
    {
      name: "Table_Tap_All",
      length: tableCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: true,
    },
  ];
}
export function SetHeaderAssetDepreciationTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Date",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Description",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Journal",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Depreciation",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Book_Value_Table_Depreciation",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
  ];
  return header;
}
export function GetCreateAssetTemplate() {
  return {
    id: 0,
    category: {
      value: { id: 0 },
      validateError: false,
    },
    subCategory: {
      value: { id: 0 },
      validateError: false,
    },
    code: {
      value: "",
      validateError: false,
    },
    imageList: [
      { croppa: {}, id: 0, fileName: "", fileType: "", rawString: "", urlImg: "", isSeleted: false },
      { croppa: {}, id: 0, fileName: "", fileType: "", rawString: "", urlImg: "", isSeleted: false },
      { croppa: {}, id: 0, fileName: "", fileType: "", rawString: "", urlImg: "", isSeleted: false },
      { croppa: {}, id: 0, fileName: "", fileType: "", rawString: "", urlImg: "", isSeleted: false },
      { croppa: {}, id: 0, fileName: "", fileType: "", rawString: "", urlImg: "", isSeleted: false },
    ],
    nameTh: {
      value: "",
      validateError: false,
    },
    nameEn: {
      value: "",
      validateError: false,
    },
    unit: {
      value: { id: 0 },
      validateError: false,
    },
    barcode: {
      value: "",
      validateError: false,
    },
    description: {
      value: "",
      validateError: false,
    },
    depreciationAccount: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
    },
    assetAccount: {
      value: { id: 0 },
      validateError: false,
    },
    accumulatedDepreciationAccount: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
    },
    usedFullYear: {
      value: "1",
      validateError: false,
      disabled: false,
    },
    scrap: {
      value: "0.00",
      validateError: false,
      disabled: false,
      isSetDefault: false,
    },
    purchaseDepreciation: {
      value: "0",
      validateError: false,
    },
    accountDepreciationMethod: {
      value: { id: 1 },
      validateError: false,
      disabled: false,
    },
    accountScrapTypeId: {
      value: 0,
      validateError: false,
    },
  };
}
export function GetCreateAssetTemplateImage() {
  return {
    id: 0,
    fileName: "",
    fileType: "",
    rawString: "",
    urlImg: "",
    isSeleted: false,
  };
}
export function GetAssetTemplateDepreciationPolicy(): any {
  const assetTemplatePolicyList = [];
  assetTemplatePolicyList.push({
    id: AssetTemplateDepreciationPolicyType.NotCalcuated,
    name: i18n.t("Not_Calcuated"),
  });
  assetTemplatePolicyList.push({
    id: AssetTemplateDepreciationPolicyType.Straight,
    name: i18n.t("Straight"),
  });
  return assetTemplatePolicyList;
}
export function GetScrapAmountText(
  accountScrapVal: number,
  accountScrapTypeId: number,
  accountScrapAmount: number
): string {
  let scrapValueText = "";
  if (accountScrapVal == AccountScrapValType.OneBath) {
    scrapValueText = "1.00 " + i18n.t("Baht");
  } else if (accountScrapVal == AccountScrapValType.TenPercent) {
    scrapValueText = "10.00%";
  } else {
    scrapValueText =
      accountScrapAmount.ToNumber() + (accountScrapTypeId == AccountScrapType.Percent ? "%" : " " + i18n.t("Baht"));
  }
  return scrapValueText;
}
export function GetAtPurchaseAmountText(
  accountValPurchase: number,
  accountValPurchaseTypeId: number,
  accountValPurchaseAmount: number
): string {
  let atPurchaseAmountText = "ไม่มี";
  if (accountValPurchase == AccountPurchaseValType.Custom) {
    atPurchaseAmountText =
      accountValPurchaseAmount.ToNumber() + (accountValPurchaseTypeId == AccountScrapType.Percent ? "%" : "");
  }
  return atPurchaseAmountText;
}
function GetExcelImportAssetTemplateJson(data: any) {
  const listImportData: any = [];
  if (data[0].length == 13) {
    data.shift();
    let count = 0;

    data.forEach((row: any) => {
      const importData: any = {};
      if (row[0]) {
        importData.id = count++;
        importData.category = row[1] ? row[1].toString().trim() : "";
        importData.subCategory = row[2] ? row[2].toString().trim() : "";
        importData.code = row[3] ? row[3].toString().trim() : "";
        importData.nameTh = row[4] ? row[4].toString().trim() : "";
        importData.nameEn = row[5] ? row[5].toString().trim() : "";
        importData.unit = row[6] ? row[6].toString().trim() : "";
        importData.description = row[7] ? row[7].toString().trim() : "";
        importData.assetAccount = row[8] ? row[8].toString().trim() : "";
        importData.usedFullYear = row[9] ? row[9].toString().trim() : "";
        importData.depreciationAccount = row[10] ? row[10].toString().trim() : "";
        importData.accumulatedDepreciationAccount = row[11] ? row[11].toString().trim() : "";
        importData.scrap = row[12] ? row[12].toString().trim() : "";
        listImportData.push(importData);
      }
    });
  }
  return listImportData;
}
export function GetAssetTemplateDepreciationPolicyTypeMenu() {
  return [
    { name: i18n.t("Not_Calcuated"), id: AssetTemplateDepreciationPolicyType.NotCalcuated },
    { name: i18n.t("Straight"), id: AssetTemplateDepreciationPolicyType.Straight },
  ];
}
export function DoImportAssetTemplateExcel(fileImport: File) {
  return ReadExcelFile(fileImport).then((value: any) => {
    return GetExcelImportAssetTemplateJson(value.contents);
  });
}
export function ConvertToImportAssetTemplateList(
  importAssetTemplateRawList: any,
  unitList: any,
  assetAccountList: any,
  depreciationAccountList: any,
  accumulatedDepreciationAccountList: any,
  assetTemplateCategoryMenuList: any
) {
  const importAssetTemplateList = [];
  if (importAssetTemplateRawList && importAssetTemplateRawList.length > 0) {
    const assetCategoryList = GetAssetTemplateCategoryList();
    const assetTemplateDepreciationPolicyTypeMenu = GetAssetTemplateDepreciationPolicyTypeMenu();
    for (const importAssetTemplateRaw of importAssetTemplateRawList) {
      const importAssetTemplate = GetCreateAssetTemplate();
      let defaultAssetAccountId = 0;
      let defaultDepreciationAccountId = 0;
      let defaultAccumulatedDepreciationAccountId = 0;
      let defaultAccountDepreciationMethodId = 0;
      let defaultAssetUnitId = 0;
      let defaultUsefulYearAmount = 0;
      importAssetTemplate.id = importAssetTemplateRaw.id;
      if (importAssetTemplateRaw.category) {
        const category = assetCategoryList.find(
          (x: any) => x.nameTh == importAssetTemplateRaw.category || x.nameEn == importAssetTemplateRaw.category
        );
        if (category) {
          importAssetTemplate.category.value = NewObject(category);
          const subCategory = category.assetTemplateSubCategoryList.find(
            (x: any) => x.nameTh == importAssetTemplateRaw.subCategory || x.nameEn == importAssetTemplateRaw.subCategory
          );
          if (subCategory) {
            importAssetTemplate.subCategory.value = NewObject(subCategory);
          }
        }
      }
      if (
        importAssetTemplate.category.value &&
        importAssetTemplate.category.value.id > 0 &&
        importAssetTemplate.subCategory.value &&
        importAssetTemplate.subCategory.value.id
      ) {
        const selectedAssetTemplateCategoryMenu = assetTemplateCategoryMenuList.find(
          (x: any) => x.assetCategoryType == importAssetTemplate.category.value.id
        );
        if (
          selectedAssetTemplateCategoryMenu &&
          selectedAssetTemplateCategoryMenu.assetSubCategoryOptionList &&
          selectedAssetTemplateCategoryMenu.assetSubCategoryOptionList.length > 0
        ) {
          const selectedAssetTemplateSubCategoryMenu = selectedAssetTemplateCategoryMenu.assetSubCategoryOptionList.find(
            (x: any) => x.assetSubCategoryType == importAssetTemplate.subCategory.value.id
          );

          if (selectedAssetTemplateSubCategoryMenu) {
            defaultAssetAccountId = selectedAssetTemplateSubCategoryMenu.assetAccountId;
            defaultDepreciationAccountId = selectedAssetTemplateSubCategoryMenu.depreciateAccountId;
            defaultAccumulatedDepreciationAccountId =
              selectedAssetTemplateSubCategoryMenu.accumulatedDepreciateAccountId;
            defaultAccountDepreciationMethodId =
              selectedAssetTemplateSubCategoryMenu.assetTemplateDepreciationPolicyType;
            defaultAssetUnitId = selectedAssetTemplateSubCategoryMenu.assetUnitId;
            defaultUsefulYearAmount = selectedAssetTemplateSubCategoryMenu.usefulYearAmount;
          } else {
            defaultAssetAccountId = 0;
            defaultDepreciationAccountId = 0;
            defaultAccumulatedDepreciationAccountId = 0;
            defaultAccountDepreciationMethodId = 0;
            defaultAssetUnitId = 0;
            defaultUsefulYearAmount = 0;
          }
        }
      }
      importAssetTemplate.code.value = importAssetTemplateRaw.code;
      importAssetTemplate.nameTh.value = importAssetTemplateRaw.nameTh;
      importAssetTemplate.nameEn.value = importAssetTemplateRaw.nameEn;
      if (importAssetTemplateRaw.unit) {
        const unit = unitList.find(
          (x: any) =>
            x.nameTh == importAssetTemplateRaw.unit ||
            x.nameEn == importAssetTemplateRaw.unit ||
            x.unitCode == importAssetTemplateRaw.unit
        );
        if (unit) {
          importAssetTemplate.unit.value = NewObject(unit);
        }
      } else {
        const unit = unitList.find((x: any) => x.id == defaultAssetUnitId);
        if (unit) {
          importAssetTemplate.unit.value = NewObject(unit);
        }
      }
      importAssetTemplate.description.value = importAssetTemplateRaw.description;
      if (importAssetTemplateRaw.assetAccount) {
        const assetAccount = assetAccountList.find((x: any) => x.code == importAssetTemplateRaw.assetAccount);
        if (assetAccount) {
          importAssetTemplate.assetAccount.value = NewObject(assetAccount);
        }
      } else {
        const assetAccount = assetAccountList.find((x: any) => x.id == defaultAssetAccountId);
        if (assetAccount) {
          importAssetTemplate.assetAccount.value = NewObject(assetAccount);
        }
      }
      const defaultAccountDepreciationMethod: any = assetTemplateDepreciationPolicyTypeMenu.find(
        (x: any) => x.id == defaultAccountDepreciationMethodId
      );
      if (defaultAccountDepreciationMethod) {
        importAssetTemplate.accountDepreciationMethod.value = NewObject(defaultAccountDepreciationMethod);
      } else {
        importAssetTemplate.accountDepreciationMethod.value = NewObject(assetTemplateDepreciationPolicyTypeMenu[0]);
      }

      if (
        importAssetTemplate.category.value.id != AssetTemplateCategoryType.Land &&
        importAssetTemplate.category.value.id != AssetTemplateCategoryType.ConstructionInProgress
      ) {
        if (importAssetTemplateRaw.usedFullYear && importAssetTemplateRaw.usedFullYear.ToNumber() > 0) {
          importAssetTemplate.usedFullYear.value = importAssetTemplateRaw.usedFullYear.ToNumber();
        } else {
          importAssetTemplate.usedFullYear.value = defaultUsefulYearAmount.toString();
        }
        if (importAssetTemplateRaw.depreciationAccount) {
          const depreciationAccount = depreciationAccountList.find(
            (x: any) => x.code == importAssetTemplateRaw.depreciationAccount
          );
          if (depreciationAccount) {
            importAssetTemplate.depreciationAccount.value = NewObject(depreciationAccount);
          }
        } else {
          const depreciationAccount = depreciationAccountList.find((x: any) => x.id == defaultDepreciationAccountId);
          if (depreciationAccount) {
            importAssetTemplate.depreciationAccount.value = NewObject(depreciationAccount);
          }
        }
        if (importAssetTemplateRaw.accumulatedDepreciationAccount) {
          const accumulatedDepreciationAccount = accumulatedDepreciationAccountList.find(
            (x: any) => x.code == importAssetTemplateRaw.accumulatedDepreciationAccount
          );
          if (accumulatedDepreciationAccount) {
            importAssetTemplate.accumulatedDepreciationAccount.value = NewObject(accumulatedDepreciationAccount);
          }
        } else {
          const accumulatedDepreciationAccount = accumulatedDepreciationAccountList.find(
            (x: any) => x.id == defaultAccumulatedDepreciationAccountId
          );
          if (accumulatedDepreciationAccount) {
            importAssetTemplate.accumulatedDepreciationAccount.value = NewObject(accumulatedDepreciationAccount);
          }
        }
        if (importAssetTemplateRaw.scrap) {
          if (importAssetTemplateRaw.scrap.toString().includes("%")) {
            importAssetTemplate.scrap.value = importAssetTemplateRaw.scrap;
          } else {
            importAssetTemplate.scrap.value = importAssetTemplateRaw.scrap.ToNumber();
          }
        }
      } else {
        importAssetTemplate.usedFullYear.value = "0";
        importAssetTemplate.usedFullYear.disabled = true;
        importAssetTemplate.scrap.disabled = true;
        importAssetTemplate.accumulatedDepreciationAccount.disabled = true;
        importAssetTemplate.depreciationAccount.disabled = true;
      }
      importAssetTemplate.scrap.isSetDefault = true;
      importAssetTemplateList.push(importAssetTemplate);
    }
  }
  return importAssetTemplateList;
}
export function ValidateUnitTemplateError(unitTemplate: any) {
  if (unitTemplate.nameTh.value == "") {
    unitTemplate.nameTh.validateError = true;
  }
  if (unitTemplate.nameEng.value == "") {
    unitTemplate.nameEng.validateError = true;
  }
  const unitNameTh = unitTemplate.nameTh.validateError;
  const unitNameEng = unitTemplate.nameEng.validateError;
  if (!unitNameTh && !unitNameEng) {
    return true;
  } else {
    return false;
  }
}

export function ConvertToUnitTemplateModel(unitTemplate: any) {
  const unitTemplateModel = {
    id: unitTemplate != null && unitTemplate.id ? unitTemplate.id : 0,
    nameTh: unitTemplate.nameTh.value,
    nameEng: unitTemplate.nameEng.value,
    unitType: unitTemplate.unitType,
    unitCode: unitTemplate.unitCode,
  };
  return unitTemplateModel;
}

export function ValidatedCreateAssetTemplate(assetTemplateList: any) {
  let isValidated = true;
  if (assetTemplateList && assetTemplateList.length > 0) {
    for (const assetTemplate of assetTemplateList) {
      assetTemplate.category.validateError = !(assetTemplate.category.value && assetTemplate.category.value.id > 0);
      if (assetTemplate.category.validateError) {
        isValidated = false;
      }
      assetTemplate.subCategory.validateError = !(
        assetTemplate.subCategory.value && assetTemplate.subCategory.value.id > 0
      );
      if (assetTemplate.subCategory.validateError) {
        isValidated = false;
      }
      assetTemplate.code.validateError = !(
        !assetTemplate.code.value ||
        (assetTemplate.code.value &&
          assetTemplate.code.value.length > 0 &&
          assetTemplate.code.value.length <= codeLimitLenght)
      );
      if (assetTemplate.code.validateError) {
        isValidated = false;
      }
      assetTemplate.nameTh.validateError = !(
        assetTemplate.nameTh.value &&
        assetTemplate.nameTh.value.length > 0 &&
        assetTemplate.nameTh.value.length <= nameLimitLenght
      );
      if (assetTemplate.nameTh.validateError) {
        isValidated = false;
      }
      assetTemplate.nameEn.validateError = !(
        assetTemplate.nameEn.value &&
        assetTemplate.nameEn.value.length > 0 &&
        assetTemplate.nameEn.value.length <= nameLimitLenght
      );
      if (assetTemplate.nameEn.validateError) {
        isValidated = false;
      }
      assetTemplate.unit.validateError = !(assetTemplate.unit.value && assetTemplate.unit.value.id > 0);
      if (assetTemplate.unit.validateError) {
        isValidated = false;
      }
      assetTemplate.barcode.validateError = !(
        !assetTemplate.barcode.value ||
        (assetTemplate.barcode.value &&
          assetTemplate.barcode.value.length >= 0 &&
          assetTemplate.barcode.value.length <= barcodeLimitLenght)
      );
      if (assetTemplate.barcode.validateError) {
        isValidated = false;
      }
      assetTemplate.description.validateError = !(
        !assetTemplate.description.value ||
        (assetTemplate.description.value &&
          assetTemplate.description.value.length >= 0 &&
          assetTemplate.description.value.length <= descriptionLimitLenght)
      );
      if (assetTemplate.description.validateError) {
        isValidated = false;
      }

      assetTemplate.assetAccount.validateError = !(
        assetTemplate.assetAccount.value && assetTemplate.assetAccount.value.id > 0
      );

      if (assetTemplate.assetAccount.validateError) {
        isValidated = false;
      }

      assetTemplate.accountDepreciationMethod.validateError = !(
        assetTemplate.accountDepreciationMethod.value && assetTemplate.accountDepreciationMethod.value.id > 0
      );

      if (assetTemplate.accountDepreciationMethod.validateError) {
        isValidated = false;
      }

      if (assetTemplate.accountDepreciationMethod.value.id == AssetTemplateDepreciationPolicyType.Straight) {
        assetTemplate.accumulatedDepreciationAccount.validateError = !(
          assetTemplate.accumulatedDepreciationAccount.value &&
          assetTemplate.accumulatedDepreciationAccount.value.id > 0
        );

        assetTemplate.usedFullYear.validateError = !(
          assetTemplate.usedFullYear.value &&
          assetTemplate.usedFullYear.value.ToNumber() > 0 &&
          assetTemplate.usedFullYear.value.ToNumber() <= usedFullYearLimit
        );

        assetTemplate.depreciationAccount.validateError = !(
          assetTemplate.depreciationAccount.value && assetTemplate.depreciationAccount.value.id > 0
        );
      }

      if (assetTemplate.depreciationAccount.validateError) {
        isValidated = false;
      }

      if (assetTemplate.accumulatedDepreciationAccount.validateError) {
        isValidated = false;
      }

      if (assetTemplate.usedFullYear.validateError) {
        isValidated = false;
      }
      if (assetTemplate.scrap.value) {
        if (assetTemplate.scrap.value.toString().includes("%")) {
          assetTemplate.scrap.validateError = !(
            assetTemplate.scrap.value.ToNumber() >= 0 && assetTemplate.scrap.value.ToNumber() <= 100
          );
        }
      } else {
        assetTemplate.scrap.validateError = false;
      }
      if (assetTemplate.scrap.validateError) {
        isValidated = false;
      }
      if (assetTemplate.purchaseDepreciation.value) {
        if (assetTemplate.purchaseDepreciation.value.toString().includes("%")) {
          assetTemplate.purchaseDepreciation.validateError = !(
            assetTemplate.purchaseDepreciation.value.ToNumber() >= 0 &&
            assetTemplate.purchaseDepreciation.value.ToNumber() <= 100
          );
        }
      } else {
        assetTemplate.purchaseDepreciation.validateError = false;
      }
      if (assetTemplate.purchaseDepreciation.validateError) {
        isValidated = false;
      }
    }
  }
  return isValidated;
}
export function ConvertToInsertAssetTemplateList(assetTemplateList: any): Array<AssetTemplateModel> {
  const insertAssetTemplateList: Array<AssetTemplateModel> = [];
  if (assetTemplateList && assetTemplateList.length > 0) {
    for (const assetTemplate of assetTemplateList) {
      const accountScrapTypeId: AccountScrapType =
        assetTemplate.scrap.value && assetTemplate.scrap.value.toString().includes("%")
          ? AccountScrapType.Percent
          : AccountScrapType.Amount;
      const accountValPurchaseTypeId: AccountPurchaseType =
        assetTemplate.purchaseDepreciation.value && assetTemplate.purchaseDepreciation.value.toString().includes("%")
          ? AccountPurchaseType.Percent
          : AccountPurchaseType.Amount;

      const insertAssetTemplate: AssetTemplateModel = {
        id: assetTemplate.id,
        nameTh: assetTemplate.nameTh.value,
        nameEn: assetTemplate.nameEn.value,
        assetCategoryId: assetTemplate.category.value.id,
        assetSubcategoryId: assetTemplate.subCategory.value.id,
        assetUnitId: assetTemplate.unit.value.id,
        accountDepreciationMethodId: assetTemplate.accountDepreciationMethod.value.id,
        assetTemplateCode: assetTemplate.code.value,
        description: assetTemplate.description.value,
        remark: "",
        dropboxLink: "",
        imagePath: "",
        assetAccountId: assetTemplate.assetAccount.value.id,
        depreciationAccountId: assetTemplate.depreciationAccount.value.id,
        accumulatedDepreciationAccountId: assetTemplate.accumulatedDepreciationAccount.value.id,
        accountUsefullYear: assetTemplate.usedFullYear.value.ToNumber(),
        accountScrapAmount: assetTemplate.scrap.value.ToNumber(),
        accountScrapTypeId: accountScrapTypeId,
        accountScrapVal: AccountScrapValType.Custom,
        accountValPurchaseAmount: assetTemplate.purchaseDepreciation.value.ToNumber(),
        accountValPurchaseTypeId: accountValPurchaseTypeId,
        accountValPurchase: AccountPurchaseValType.Custom,
        barcode: assetTemplate.barcode.value,
        isDeleted: false,
        imageList: [],
      };

      if (insertAssetTemplate.accountDepreciationMethodId == AssetTemplateDepreciationPolicyType.NotCalcuated) {
        insertAssetTemplate.accumulatedDepreciationAccountId = 0;
        insertAssetTemplate.depreciationAccountId = 0;
        insertAssetTemplate.accountScrapAmount = 0;
        insertAssetTemplate.accountUsefullYear = 0;
      }

      if (assetTemplate.imageList && assetTemplate.imageList.length > 0) {
        assetTemplate.imageList.forEach((image: any) => {
          insertAssetTemplate.imageList.push({
            fileName: image.fileName,
            fileType: image.fileType,
            fileUrl: image.urlImg,
            id: image.id,
            isSeleted: image.isSeleted,
            rawString: image.rawString,
          });
        });
      }

      insertAssetTemplateList.push(insertAssetTemplate);
    }
  }
  return insertAssetTemplateList;
}

export function SetAssetTemplateForEdit(createAssetTemplate: any, assetTemplateDetail: any) {
  createAssetTemplate.id = assetTemplateDetail.id;
  createAssetTemplate.category.value.id = assetTemplateDetail.assetCategoryId;
  createAssetTemplate.subCategory.value.id = assetTemplateDetail.assetSubcategoryId;
  createAssetTemplate.code.value = assetTemplateDetail.assetTemplateCode;
  createAssetTemplate.imageList = assetTemplateDetail.imageList;
  createAssetTemplate.nameTh.value = assetTemplateDetail.nameTh;
  createAssetTemplate.nameEn.value = assetTemplateDetail.nameEn;
  createAssetTemplate.unit.value.id = assetTemplateDetail.assetUnitId;
  createAssetTemplate.barcode.value = assetTemplateDetail.barcode;
  createAssetTemplate.description.value = assetTemplateDetail.description;
  createAssetTemplate.depreciationAccount.value.id = assetTemplateDetail.depreciationAccountId;
  createAssetTemplate.assetAccount.value.id = assetTemplateDetail.assetAccountId;
  createAssetTemplate.accumulatedDepreciationAccount.value.id = assetTemplateDetail.accumulatedDepreciationAccountId;
  createAssetTemplate.usedFullYear.value = assetTemplateDetail.accountUsefullYear;
  createAssetTemplate.scrap.value = assetTemplateDetail.accountScrapAmount;
  createAssetTemplate.purchaseDepreciation.value = assetTemplateDetail.accountValPurchase;
  createAssetTemplate.accountDepreciationMethod.value.id = assetTemplateDetail.accountDepreciationMethodId;
  createAssetTemplate.accountScrapTypeId.value = assetTemplateDetail.accountScrapTypeId;
}
export function GetCreateAssetCarryBalance() {
  return {
    id: 0,
    category: {
      value: { id: 0 },
      validateError: false,
    },
    subCategory: {
      value: { id: 0 },
      validateError: false,
    },
    assetTemplate: {
      value: { id: 0 },
      validateError: false,
    },
    purchaseDate: {
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    purchaseCost: {
      value: "",
      validateError: false,
    },
    carryingDepreciatedAmount: {
      value: "",
      validateError: false,
    },
    depreciationDate: {
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    scarpTotal: 0,
    atPurchaseDepreciatedTotal: 0,
    serialNo: {
      value: "",
      validateError: false,
    },
    location: {
      value: "",
      validateError: false,
    },
    description: {
      value: "",
      validateError: false,
    },
  };
}

export function GetInsertAssetCarryBalance(assetCarryBalanceRawList: any) {
  const assetList = [];
  if (assetCarryBalanceRawList && assetCarryBalanceRawList.length > 0) {
    for (const assetCarryBalanceRaw of assetCarryBalanceRawList) {
      let depreciationDate: any = new Date(assetCarryBalanceRaw.depreciationDate.value);
      depreciationDate = !isNaN(depreciationDate.getTime()) ? depreciationDate : new Date();
      assetList.push({
        assetTemplateId: assetCarryBalanceRaw.assetTemplate.value.id,
        purchaseDate: assetCarryBalanceRaw.purchaseDate.value.ToDateJsonString(),
        depreciateDate: depreciationDate.ToDateJsonString(),
        purchaseCost: assetCarryBalanceRaw.purchaseCost.value,
        carryingDepreciatedAmount: assetCarryBalanceRaw.carryingDepreciatedAmount.value,
        depreciateCalculateLatestDate: depreciationDate.AddDayAndToDateJsonString(-1).ToDateJsonString(),
        scrapAmount: assetCarryBalanceRaw.scarpTotal,
        serialNumber: assetCarryBalanceRaw.serialNo.value,
        location: assetCarryBalanceRaw.location.value,
        description: assetCarryBalanceRaw.description.value,
      });
    }
  }
  return assetList;
}

export function GetUpdateAssetCarryBalance(assetCarryBalanceRaw: any) {
  let asset = {};
  let depreciationDate: any = new Date(assetCarryBalanceRaw.depreciationDate.value);
  depreciationDate = !isNaN(depreciationDate.getTime()) ? depreciationDate : new Date();
  asset = {
    id: assetCarryBalanceRaw.id,
    assetTemplateId: assetCarryBalanceRaw.assetTemplate.value.id,
    purchaseDate: assetCarryBalanceRaw.purchaseDate.value.ToDateJsonString(),
    depreciateDate: depreciationDate.ToDateJsonString(),
    purchaseCost: assetCarryBalanceRaw.purchaseCost.value,
    carryingDepreciatedAmount: assetCarryBalanceRaw.carryingDepreciatedAmount.value,
    depreciateCalculateLatestDate: depreciationDate.AddDayAndToDateJsonString(-1).ToDateJsonString(),
    scrapAmount: assetCarryBalanceRaw.scarpTotal,
    serialNumber: assetCarryBalanceRaw.serialNo.value,
    location: assetCarryBalanceRaw.location.value,
    description: assetCarryBalanceRaw.description.value,
  };

  return asset;
}

export function ValidateAssetCarryBalance(
  assetCarryBalanceRawList: any,
  isLockPeriod: boolean,
  lockPeriodEndDate: Date
) {
  let isValidated = true;
  let validatedErrorType = ValidatedErrorCarryBalanceType.None;
  if (assetCarryBalanceRawList && assetCarryBalanceRawList.length > 0) {
    for (const assetCarryBalanceRaw of assetCarryBalanceRawList) {
      if (assetCarryBalanceRaw.category.value && assetCarryBalanceRaw.category.value.id > 0) {
        assetCarryBalanceRaw.category.validateError = false;
      } else {
        assetCarryBalanceRaw.category.validateError = true;
        isValidated = false;
      }
      if (assetCarryBalanceRaw.subCategory.value && assetCarryBalanceRaw.subCategory.value.id > 0) {
        assetCarryBalanceRaw.subCategory.validateError = false;
      } else {
        assetCarryBalanceRaw.subCategory.validateError = true;
        isValidated = false;
      }
      if (assetCarryBalanceRaw.assetTemplate.value && assetCarryBalanceRaw.assetTemplate.value.id > 0) {
        assetCarryBalanceRaw.assetTemplate.validateError = false;
      } else {
        assetCarryBalanceRaw.assetTemplate.validateError = true;
        isValidated = false;
      }

      if (
        assetCarryBalanceRaw.assetTemplate.value &&
        assetCarryBalanceRaw.assetTemplate.value.accountDepreciationMethodId ==
          AssetTemplateDepreciationPolicyType.NotCalcuated
      ) {
        assetCarryBalanceRaw.carryingDepreciatedAmount.disabled = true;
        assetCarryBalanceRaw.carryingDepreciatedAmount.value = "0.00";
        assetCarryBalanceRaw.depreciationDate.disabled = true;
        assetCarryBalanceRaw.depreciationDate.value = "";
        assetCarryBalanceRaw.depreciationDate.validateError = false;
      } else {
        assetCarryBalanceRaw.carryingDepreciatedAmount.disabled = false;
        assetCarryBalanceRaw.depreciationDate.disabled = false;

        const depreciationDate = new Date(assetCarryBalanceRaw.depreciationDate.value);

        if (!isNaN(depreciationDate.getTime())) {
          assetCarryBalanceRaw.depreciationDate.validateError = false;
        } else {
          assetCarryBalanceRaw.depreciationDate.validateError = true;
          isValidated = false;
        }
      }

      if (assetCarryBalanceRaw.purchaseDate.value) {
        assetCarryBalanceRaw.purchaseDate.validateError = false;
      } else {
        assetCarryBalanceRaw.purchaseDate.validateError = true;
        isValidated = false;
      }
      if (assetCarryBalanceRaw.depreciationDate.value) {
        if (
          assetCarryBalanceRaw.purchaseDate.value &&
          assetCarryBalanceRaw.depreciationDate.value < assetCarryBalanceRaw.purchaseDate.value
        ) {
          assetCarryBalanceRaw.depreciationDate.validateError = true;
          isValidated = false;
        }
        if (isLockPeriod && assetCarryBalanceRaw.depreciationDate.value < lockPeriodEndDate) {
          assetCarryBalanceRaw.depreciationDate.validateError = true;
          validatedErrorType = ValidatedErrorCarryBalanceType.LockByPeriod;
          isValidated = false;
        }
      } else {
        assetCarryBalanceRaw.depreciationDate.validateError = true;
        isValidated = false;
      }

      if (assetCarryBalanceRaw.purchaseCost.value) {
        if (
          assetCarryBalanceRaw.purchaseCost.value.ToNumber() <
          assetCarryBalanceRaw.scarpTotal.ToNumber() +
            assetCarryBalanceRaw.atPurchaseDepreciatedTotal.ToNumber() +
            assetCarryBalanceRaw.carryingDepreciatedAmount.value.ToNumber()
        ) {
          if (
            !assetCarryBalanceRaw.carryingDepreciatedAmount &&
            assetCarryBalanceRaw.carryingDepreciatedAmount.value.ToNumber() == 0
          ) {
            assetCarryBalanceRaw.purchaseCost.validateError = true;
            isValidated = false;
          } else {
            assetCarryBalanceRaw.purchaseCost.validateError = false;
          }
        } else {
          assetCarryBalanceRaw.purchaseCost.validateError = false;
        }
      } else {
        assetCarryBalanceRaw.purchaseCost.validateError = true;
        isValidated = false;
      }
      if (assetCarryBalanceRaw.carryingDepreciatedAmount.value) {
        if (
          assetCarryBalanceRaw.purchaseCost.value.ToAccountingRoundUpNumber() <
          assetCarryBalanceRaw.scarpTotal.ToAccountingRoundUpNumber() +
            assetCarryBalanceRaw.atPurchaseDepreciatedTotal.ToAccountingRoundUpNumber() +
            assetCarryBalanceRaw.carryingDepreciatedAmount.value.ToAccountingRoundUpNumber()
        ) {
          if (
            assetCarryBalanceRaw.carryingDepreciatedAmount.value.ToAccountingRoundUpNumber() >
            assetCarryBalanceRaw.purchaseCost.value.ToAccountingRoundUpNumber()
          ) {
            isValidated = false;
            validatedErrorType = ValidatedErrorCarryBalanceType.Depreciation;
            assetCarryBalanceRaw.carryingDepreciatedAmount.validateError = true;
          } else if (
            assetCarryBalanceRaw.purchaseCost.value.ToAccountingRoundUpNumber() -
              assetCarryBalanceRaw.carryingDepreciatedAmount.value.ToAccountingRoundUpNumber() <
            assetCarryBalanceRaw.scarpTotal.ToAccountingRoundUpNumber()
          ) {
            isValidated = false;
            validatedErrorType = ValidatedErrorCarryBalanceType.ScrapValue;
            assetCarryBalanceRaw.carryingDepreciatedAmount.validateError = true;
          }
        } else {
          assetCarryBalanceRaw.carryingDepreciatedAmount.validateError = false;
        }
      } else {
        assetCarryBalanceRaw.carryingDepreciatedAmount.validateError = false;
      }

      if (assetCarryBalanceRaw.serialNo.value.length > maxLengthSerialNo) {
        isValidated = false;
        assetCarryBalanceRaw.serialNo.validateError = true;
      } else {
        assetCarryBalanceRaw.serialNo.validateError = false;
      }

      if (assetCarryBalanceRaw.location.value.length > maxLengthLocation) {
        isValidated = false;
        assetCarryBalanceRaw.location.validateError = true;
      } else {
        assetCarryBalanceRaw.location.validateError = false;
      }

      if (assetCarryBalanceRaw.description.value.length > maxLengthDescription) {
        isValidated = false;
        assetCarryBalanceRaw.description.validateError = true;
      } else {
        assetCarryBalanceRaw.description.validateError = false;
      }
    }
  }
  return { isValidated: isValidated, validatedErrorType: validatedErrorType };
}

export function ValidateAssetCarryBalanceForUpdate(assetCarryBalanceRawList: any) {
  let isValidated = true;
  const validatedErrorType = ValidatedErrorCarryBalanceType.None;
  if (assetCarryBalanceRawList && assetCarryBalanceRawList.length > 0) {
    for (const assetCarryBalanceRaw of assetCarryBalanceRawList) {
      if (assetCarryBalanceRaw.serialNo.value.length > maxLengthSerialNo) {
        isValidated = false;
        assetCarryBalanceRaw.serialNo.validateError = true;
      } else {
        assetCarryBalanceRaw.serialNo.validateError = false;
      }

      if (assetCarryBalanceRaw.location.value.length > maxLengthLocation) {
        isValidated = false;
        assetCarryBalanceRaw.location.validateError = true;
      } else {
        assetCarryBalanceRaw.location.validateError = false;
      }

      if (assetCarryBalanceRaw.description.value.length > maxLengthDescription) {
        isValidated = false;
        assetCarryBalanceRaw.description.validateError = true;
      } else {
        assetCarryBalanceRaw.description.validateError = false;
      }
    }
  }
  return { isValidated: isValidated, validatedErrorType: validatedErrorType };
}
export function GetScrapTotal(
  purchaseCost: number,
  accountScrapAmount: number,
  accountScrapVal: AccountScrapValType,
  accountScrapTypeId: AccountScrapType
) {
  let scrapAmount = 0;
  if (accountScrapVal == AccountScrapValType.OneBath) {
    scrapAmount = 1;
  } else if (accountScrapVal == AccountScrapValType.TenPercent) {
    scrapAmount = (10 * purchaseCost.ToNumber()) / 100;
  } else {
    scrapAmount =
      accountScrapTypeId == AccountScrapType.Percent
        ? (accountScrapAmount.ToNumber() * purchaseCost.ToNumber()) / 100
        : accountScrapAmount.ToNumber();
  }
  return scrapAmount.ToAccountingRoundUp();
}
export function GetAtPurchaseDepreciatedTotal(
  purchaseCost: number,
  scrapTotal: number,
  accountValPurchaseAmount: number,
  accountValPurchase: AccountPurchaseValType,
  accountValPurchaseTypeId: AccountPurchaseType
) {
  let atPurchaseDepreciatedTotal = 0;
  if (accountValPurchase == AccountPurchaseValType.Custom) {
    atPurchaseDepreciatedTotal =
      accountValPurchaseTypeId == AccountPurchaseType.Percent
        ? (accountValPurchaseAmount.ToNumber() * purchaseCost.ToNumber()) / 100
        : accountValPurchaseAmount.ToNumber();
  }
  if (purchaseCost.ToNumber() - scrapTotal.ToNumber() < atPurchaseDepreciatedTotal.ToNumber()) {
    atPurchaseDepreciatedTotal =
      purchaseCost.ToNumber() - scrapTotal.ToNumber() > 0 ? purchaseCost.ToNumber() - scrapTotal.ToNumber() : 0;
  }
  return atPurchaseDepreciatedTotal.ToAccountingRoundUp();
}

function GetExcelImportAssetCarryBalanceJson(data: any) {
  const listImportData: any = [];
  if (data[1].length == 6) {
    data.shift();
    let count = 0;
    data.forEach((row: any) => {
      if (row[0]) {
        const importData: any = {};
        importData.id = count++;
        importData.code = row[1] ? row[1].toString().trim() : "";
        importData.purchaseDate = row[2] ? GetDateJsonString(row[2].toString().trim()) : "";
        importData.purchaseCost = row[3] ? row[3].toString().trim() : "";
        importData.carryingDepreciatedAmount = row[4] ? row[4].toString().trim() : "";
        importData.depreciationDate = row[5] ? GetDateJsonString(row[5].toString().trim()) : "";
        listImportData.push(importData);
      }
    });
  }
  return listImportData;
}

export function DoImportAssetCarryBalanceExcel(fileImport: File) {
  return ReadExcelFile(fileImport).then((value: any) => {
    return GetExcelImportAssetCarryBalanceJson(value.contents);
  });
}
export function GetAssetTemplateCode(importAssetTemplateJsonList: any) {
  const assetTemplateCode = [];
  if (importAssetTemplateJsonList && importAssetTemplateJsonList.length > 0) {
    for (const importAssetTemplateJson of importAssetTemplateJsonList) {
      if (importAssetTemplateJson.code) {
        assetTemplateCode.push(importAssetTemplateJson.code);
      }
    }
  }
  return assetTemplateCode;
}
export function GetImportAssetCarryBalanceList(importAssetTemplateJsonList: any, assetTemplateList: any) {
  const importAssetCarryBalanceList = [];
  if (importAssetTemplateJsonList && importAssetTemplateJsonList.length > 0) {
    const dateNull: any = null;
    const categoryList = GetAssetTemplateCategoryList();
    for (const importAssetTemplateJson of importAssetTemplateJsonList) {
      const assetCarryBalance: any = GetCreateAssetCarryBalance();
      assetCarryBalance.purchaseCost.value = importAssetTemplateJson.purchaseCost.ToNumber().FormatMoney();
      assetCarryBalance.carryingDepreciatedAmount.value = importAssetTemplateJson.carryingDepreciatedAmount

        .ToNumber()
        .FormatMoney();
      if (importAssetTemplateJson.purchaseDate) {
        assetCarryBalance.purchaseDate.value = importAssetTemplateJson.purchaseDate;
      } else {
        assetCarryBalance.purchaseDate.value = dateNull;
      }
      if (importAssetTemplateJson.depreciationDate) {
        assetCarryBalance.depreciationDate.value = importAssetTemplateJson.depreciationDate;
      } else {
        assetCarryBalance.depreciationDate.value = dateNull;
      }
      if (importAssetTemplateJson.code) {
        const assetTemplate = assetTemplateList.find((x: any) => x.assetTemplateCode == importAssetTemplateJson.code);
        if (assetTemplate) {
          assetCarryBalance.assetTemplate.value.id = assetTemplate.id;
          assetCarryBalance.assetTemplate.value.code = assetTemplate.assetTemplateCode;
          assetCarryBalance.assetTemplate.value.nameTh = assetTemplate.nameTh;
          assetCarryBalance.assetTemplate.value.nameEn = assetTemplate.nameEn;
          const category = categoryList.find((x: any) => x.id == assetTemplate.assetCategoryId);
          if (category) {
            assetCarryBalance.category.value = NewObject(category);
            const subCategory = category.assetTemplateSubCategoryList.find(
              (x: any) => x.id == assetTemplate.assetSubcategoryId
            );
            if (subCategory) {
              assetCarryBalance.subCategory.value = NewObject(subCategory);
            }
          }
          assetCarryBalance.scarpTotal = assetTemplate.accountScrapAmount;
        }
      }
      importAssetCarryBalanceList.push(assetCarryBalance);
    }
  }
  return importAssetCarryBalanceList;
}
